/* import __COLOCATED_TEMPLATE__ from './side-panel.hbs'; */
/* RESPONSIBLE TEAM: team-proactive-support */

import Component from '@glimmer/component';
export default class SidePanel extends Component {
  get showCloseIcon() {
    return this.args.showCloseIcon ?? true;
  }
}